// One id per open Take Control window (not per person), so the server can tell
// two windows apart even when the same account has the PC open twice.
export function newRemoteControlClientId() {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
}
